import { useEffect } from "react";

import { HeaderWithNextButtonLayout } from "@components";
import Rewards from "./components/Rewards";

import { useQualifications } from "@hooks/HRM/employee/useQualifications";

export interface QualificationRewardsInfoPropsType {
  id: number | null;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  isProfileDisabled: boolean;
}

function QualificationRewards({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  isProfileDisabled,
}: QualificationRewardsInfoPropsType) {
  const {
    qualificationInfo,
    changeRewardsInfo,
    removeRewardInfo,

    getQualificationInfoRequestOngoing,

    updateRewardRequestOngoing,
    updateRewardSuccess,
    updateRewardFailed,

    deleteRewardRequestOngoing,
    deleteRewardSuccess,
    deleteRewardFailed,
  } = useQualifications(id);

  const { awards } = qualificationInfo || {};

  useEffect(() => {
    setIsSuccessModalOpen(updateRewardSuccess || deleteRewardSuccess);
    setIsErrorModalOpen(updateRewardFailed || deleteRewardFailed);
  }, [
    updateRewardSuccess,
    deleteRewardSuccess,
    updateRewardFailed,
    deleteRewardFailed,
  ]);

  return (
    <HeaderWithNextButtonLayout
      title="EMPLOYEE.REWARDS_INFO.HEADING"
      subtitle="EMPLOYEE.REWARDS_INFO.DESCRIPTION"
      action={() => changeActiveTab(7)}
    >
      <Rewards
        rewardsInfo={awards}
        changeRewardsInfo={changeRewardsInfo}
        removeRewardInfo={removeRewardInfo}
        getQualificationInfoRequestOngoing={getQualificationInfoRequestOngoing}
        updateRewardRequestOngoing={updateRewardRequestOngoing}
        deleteRewardRequestOngoing={deleteRewardRequestOngoing}
        isProfileDisabled={isProfileDisabled}
      />
    </HeaderWithNextButtonLayout>
  );
}

export default QualificationRewards;
